import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import {useHistory} from 'react-router-dom'


import SearchIcon from "@mui/icons-material/Search";
import BadgeIcon from "@mui/icons-material/Badge";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { CRM_LeyendaAuditoria } from "./CRM_LeyendaAuditoria";
import { CRM_LeyendaDepartamento } from "./CRM_LeyendaDepartamento";
import { construirAuditoriaLocal } from "./construirAuditoriaLocal";

const FORM_VACIO = {
  razonSocial: "",
  rfc: "XAXX010101000",
  tipoRegimen: "Moral",
  estatus: "1",
  origen: "",
  tipoCliente: "",
  etiqueta: "",
  telefono: "",
  correo: "",
  nombreCompleto: "",
  idvendedor: "",
  idzona: "",
  zona: "",
};

// Solo dígitos, máximo 10 (validación de captura de Teléfono)
const filtrarTelefono = (value) => value.replace(/\D/g, "").slice(0, 10);

// Caracteres válidos en un correo (local-part + dominio), máximo 100 (validación de captura de Correo)
const filtrarCorreo = (value) => value.replace(/[^a-zA-Z0-9@._\-+]/g, "").slice(0, 100);

// Solo letras (con acentos/ñ) y números — sin símbolos (validación de captura de Nombre completo)
const filtrarNombreCompleto = (value) => value.replace(/[^a-zA-Z0-9À-ÿ\s]/g, "");

const REGEX_CORREO = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Estados permitidos para la Zona — solo los idestado 0018 y 0025 (comparación normalizada sin ceros a la izquierda)
const IDS_ESTADO_ZONA = ["0018", "0025"].map((id) => String(Number(id)));
const esEstadoZonaPermitido = (idestado) => IDS_ESTADO_ZONA.includes(String(Number(idestado)));

// Convierte la respuesta de Clientes/GetInfoClienteID (info_General_cliente, mdl_Info_Cliente_CRM) al formulario de esta pantalla
// estatus_cliente/origen_cliente/tipo_cliente llegan como id (string) — se resuelven contra los catálogos de opciones
const mapClienteToForm = (cliente) => ({
  razonSocial: cliente.razon_social || "",
  rfc: cliente.rfc || "",
  tipoRegimen: cliente.tipo_persona === "F" ? "Física" : "Moral",
  estatus: cliente.estatus_cliente ?? "",
  origen: cliente.origen_cliente ?? "",
  tipoCliente: cliente.tipo_cliente ?? "",
  etiqueta: cliente.etiqueta ?? "",
  telefono: cliente.telefono || "",
  correo: cliente.correo || "",
  nombreCompleto: cliente.nombre_completo || "",
  idvendedor: cliente.idvendedor || "",
  idzona: cliente.zona || "",
  zona: cliente.zona_nombre || "",
});

export const CRM_DetalleGenerales = ({
  esNuevo,
  cliente,
  idcliente,
  opcionesGenerales = { estatus: [], origen: [], tipo: [], tecnologia: [], etiqueta: [] },
  opcionesUbicacion = { estado: [], municipio: [] },
  onClienteRegistrado,
  onTipoPersonaGuardado,
  soloLectura = false,
  validado,
  responsableDepartamento = [],
}) => {
  const { empleado } = useSelector((store) => store.usuario);

  const [editing, setEditing] = useState(esNuevo);
  const [form, setForm] = useState(FORM_VACIO);
  const [auditoria, setAuditoria] = useState(cliente);
  const [clientePrincipal, setClientePrincipal] = useState(true);
  const [validacion, setValidacion] = useState(!!validado?.validado);
  const [busquedaCliente, setBusquedaCliente] = useState("");
  const [clienteAsociado, setClienteAsociado] = useState(null);
  const [vendedores, setVendedores] = useState([]);
  const [clientesCRM, setClientesCRM] = useState([]);
  const [busquedaPropietario, setBusquedaPropietario] = useState("");
  const [propietarioSeleccionado, setPropietarioSeleccionado] = useState(null);
  const [mostrarPropietarios, setMostrarPropietarios] = useState(false);
  const [mostrarBuscadorZona, setMostrarBuscadorZona] = useState(false);
  const [zonaCP, setZonaCP] = useState("");
  const [zonaIdEstado, setZonaIdEstado] = useState("");
  const [zonaIdMunicipio, setZonaIdMunicipio] = useState("");
  const [localidadesZona, setLocalidadesZona] = useState([]);
  const [buscandoZona, setBuscandoZona] = useState(false);
  const [filtroLocalidadZona, setFiltroLocalidadZona] = useState("");
  const zonaPanelRef = useRef(null);

  const fieldClass = () => (editing ? "crm-field-editable" : "crm-field-readonly");

  // Cierra el panel de Zona al hacer click fuera de él
  useEffect(() => {
    if (!mostrarBuscadorZona) return;

    const handleClickFuera = (e) => {
      if (zonaPanelRef.current && !zonaPanelRef.current.contains(e.target)) {
        setMostrarBuscadorZona(false);
      }
    };

    document.addEventListener("mousedown", handleClickFuera);
    return () => document.removeEventListener("mousedown", handleClickFuera);
  }, [mostrarBuscadorZona]);
  const history = useHistory();

  // Catálogo de asesores — mismo origen de datos que el campo Vendedor de RegistroClienteMainScreen.js
  useEffect(() => {
    request
      .get("DDLVendedor/Listado")
      .then((result) => setVendedores(result))
      .catch((error) => Swal.fire("CLIENTES", JSON.stringify(error), "error"));
  }, []);

  // Listado de clientes del CRM — mismo origen que el buscador de CRM_Dashboard, usado para asociar cliente principal
  useEffect(() => {
    request
      .get("Clientes/GetListadoClientesCRM")
      .then((result) => setClientesCRM(result || []))
      .catch((error) => Swal.fire("CLIENTES", JSON.stringify(error), "error"));
  }, []);

  // Carga el formulario con los datos reales del cliente cuando llegan de Clientes/GetInfoClienteID
  useEffect(() => {
    setForm(cliente ? mapClienteToForm(cliente) : FORM_VACIO);
    setAuditoria(cliente);
  }, [cliente]);

  // validado llega después del primer render (fetch async en CRM_DetalleScreen) — se sincroniza aquí
  useEffect(() => {
    if (esNuevo) return;
    setValidacion(!!validado?.validado);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validado]);

  // Sincroniza el propietario seleccionado con el catálogo de vendedores cargado
  useEffect(() => {
    if (!form.idvendedor || vendedores.length === 0) {
      setPropietarioSeleccionado(null);
      return;
    }
    const encontrado = vendedores.find(
      (v) => String(v.idvendedor) === String(form.idvendedor),
    );
    setPropietarioSeleccionado(encontrado || null);
  }, [form.idvendedor, vendedores]);

  // El campo "principal" del cliente: null/vacío = es principal, idcliente = asociado a otro principal
  useEffect(() => {
    if (!cliente) {
      setClientePrincipal(true);
      setClienteAsociado(null);
      return;
    }
    if (!cliente.principal) {
      setClientePrincipal(true);
      setClienteAsociado(null);
      return;
    }
    setClientePrincipal(false);
  }, [cliente]);

  // Resuelve el cliente principal asociado contra el listado del CRM cuando ambos están disponibles
  useEffect(() => {
    if (!cliente?.principal || clientesCRM.length === 0) return;
    const encontrado = clientesCRM.find(
      (c) => String(c.idcliente) === String(cliente.principal),
    );
    setClienteAsociado(encontrado || null);
  }, [cliente, clientesCRM]);

  const handleChange = (campo) => (e) => {
    setForm((prev) => ({ ...prev, [campo]: e.target.value }));
  };

  const handleChangeTelefono = (e) => {
    setForm((prev) => ({ ...prev, telefono: filtrarTelefono(e.target.value) }));
  };

  const handleChangeCorreo = (e) => {
    setForm((prev) => ({ ...prev, correo: filtrarCorreo(e.target.value) }));
  };

  const handleChangeNombreCompleto = (e) => {
    setForm((prev) => ({ ...prev, nombreCompleto: filtrarNombreCompleto(e.target.value) }));
  };

  const handleEditar = () => setEditing(true);

  const handleCancelar = () => {
    setForm(cliente ? mapClienteToForm(cliente) : FORM_VACIO);
    setClientePrincipal(!cliente?.principal);
    setValidacion(!!validado?.validado);
    setBusquedaCliente("");
    setClienteAsociado(
      cliente?.principal
        ? clientesCRM.find(
            (c) => String(c.idcliente) === String(cliente.principal),
          ) || null
        : null,
    );
    setBusquedaPropietario("");
    setMostrarBuscadorZona(false);
    setZonaCP("");
    setZonaIdEstado("");
    setZonaIdMunicipio("");
    setLocalidadesZona([]);
    if (!esNuevo) setEditing(false);
  };

  const handleGuardar = () => {
    if (esNuevo) {
      guardarClienteNuevo();
      return;
    }
    guardarClienteExistente();
  };

  // Solo se llama si la validación cambió respecto al valor original — evita un POST innecesario en cada guardado
  const guardarValidacion = () =>
    request.post("Clientes/GuardarValidacionCliente", { idcliente: Number(idcliente), validacion });

  // Arma el body de mdlClientes — mismo formato para alta y edición, cambia solo idcliente y el destino del resultado
  // Por ahora solo se usa el endpoint de Persona Moral, sin importar el Tipo de régimen seleccionado
  const buildBody = (idclienteBody) => {
    const clientePrincipalBody = clientePrincipal
      ? null
      : clienteAsociado
        ? String(clienteAsociado.idcliente)
        : null;

    return {
      idcliente: idclienteBody,
      razon_social: form.razonSocial,
      rfc: form.rfc,
      tipo_persona: form.tipoRegimen === "Física" ? "F" : "M",
      medio_contacto: "LL",
      tiempo_agricultor: 1,
      regimen_fiscal: "626",
      referencia: "",
      agrupacion: "I",
      tipo_venta: "CR",
      idvendedor: form.idvendedor,
      cliente_principal: clientePrincipalBody,
      estatus_cliente: form.estatus || null,
      origen: form.origen || null,
      tipo_cliente: form.tipoCliente || null,
      etiqueta: form.etiqueta || null,
      telefono: form.telefono || null,
      correo: form.correo || null,
      nombre_completo: form.nombreCompleto || null,
      zona: form.idzona || null,
    };
  };

  const validarForm = () => {
    if (!form.razonSocial.trim()) {
      Swal.fire("CLIENTES", "El campo Razón Social es Obligatorio", "warning");
      return false;
    }
    if (!form.idvendedor) {
      Swal.fire(
        "CLIENTES",
        "Favor de seleccionar el propietario relacionado con este cliente",
        "warning",
      );
      return false;
    }
    if (form.telefono && form.telefono.length !== 10) {
      Swal.fire("CLIENTES", "El teléfono debe tener 10 dígitos", "warning");
      return false;
    }
    if (form.correo && !REGEX_CORREO.test(form.correo)) {
      Swal.fire("CLIENTES", "El correo capturado no es válido", "warning");
      return false;
    }
    return true;
  };

  const guardarClienteNuevo = () => {
    if (!validarForm()) return;

    const endpoint = "Clientes/Persona_Moral_Vendedor";

    request
      .post(endpoint, buildBody(0))
      .then(async (result) => {
        await Swal.fire("CLIENTES", "Cliente registrado con éxito", "success");
        history.push('/DashClientes/Main');
        return
        onClienteRegistrado(Number(result) || 0);
      })
      .catch((error) => Swal.fire("CLIENTES", JSON.stringify(error), "error"));
  };

  const guardarClienteExistente = () => {
    if (!validarForm()) return;

    const endpoint = "Clientes/Persona_Moral_Vendedor";
    const validacionCambio = validacion !== !!validado?.validado;

    request
      .post(endpoint, buildBody(Number(idcliente)))
      .then(() => (validacionCambio ? guardarValidacion() : Promise.resolve()))
      .then(async () => {
        await Swal.fire("CLIENTES", "Cambios guardados con éxito", "success");
        setAuditoria(construirAuditoriaLocal(empleado));
        setEditing(false);
        // Avisa al padre el tipo de persona recién guardado — CRM_DetalleScreen no vuelve a
        // pedir GetInfoClienteID después de este guardado, así que sin esto, secciones como
        // Buró de crédito (que muestran/ocultan campos según tipoPersona) seguían mostrando lo
        // que trajo la carga inicial hasta recargar la página completa
        onTipoPersonaGuardado?.(form.tipoRegimen === "Física" ? "F" : "M");
      })
      .catch((error) => Swal.fire("CLIENTES", JSON.stringify(error), "error"));
  };

  // Coincidencias del listado de clientes CRM para asociar como cliente principal
  const resultadosClientePrincipal = clientesCRM.filter((c) => {
    const q = busquedaCliente.toLowerCase();
    return (
      busquedaCliente.length > 1 &&
      ((c.razon_social || "").toLowerCase().includes(q) ||
        (c.rfc || "").toLowerCase().includes(q))
    );
  });

  const handleSeleccionarClientePrincipal = (c) => {
    setClienteAsociado(c);
    setBusquedaCliente("");
  };

  const handleQuitarAsociado = () => setClienteAsociado(null);

  // Coincidencias del catálogo de vendedores para asignar como propietario del cliente
  // Sin texto de búsqueda se muestra el listado completo (al hacer focus en el campo)
  const resultadosPropietario = mostrarPropietarios
    ? vendedores.filter((v) =>
        (v.vendedor || "")
          .toLowerCase()
          .includes(busquedaPropietario.toLowerCase()),
      )
    : [];

  const handleSeleccionarPropietario = (v) => {
    setForm((prev) => ({ ...prev, idvendedor: v.idvendedor }));
    setBusquedaPropietario("");
    setMostrarPropietarios(false);
  };

  const handleQuitarPropietario = () =>
    setForm((prev) => ({ ...prev, idvendedor: "" }));

  // Buscador de Zona — mismo flujo CP/Estado/Municipio → Localidad usado en Ubicación
  const handleAbrirBuscadorZona = () => {
    if (!editing) return;
    setMostrarBuscadorZona(true);
  };

  const buscarZonaPorCP = () => {
    if (!zonaCP) return;
    setBuscandoZona(true);
    request
      .get(`Clientes/GetLocalidadesCRM?codigo_postal=${zonaCP}`)
      .then((result) => {
        const localidades = result || [];
        setLocalidadesZona(localidades);

        const idmunicipio = localidades[0]?.idmunicipio || "";
        const municipioEncontrado = opcionesUbicacion.municipio.find((m) => String(m.idmunicipio) === String(idmunicipio));
        const estadoEncontrado = municipioEncontrado
          ? opcionesUbicacion.estado.find((e) => String(e.idestado) === String(municipioEncontrado.idestado))
          : null;

        setZonaIdMunicipio(idmunicipio);
        setZonaIdEstado(estadoEncontrado?.idestado || "");
        setFiltroLocalidadZona("");
      })
      .catch((error) => Swal.fire("CLIENTES", JSON.stringify(error), "error"))
      .finally(() => setBuscandoZona(false));
  };

  const handleChangeZonaEstado = (e) => {
    setZonaIdEstado(e.target.value);
    setZonaIdMunicipio("");
    setLocalidadesZona([]);
    setFiltroLocalidadZona("");
  };

  const handleChangeZonaMunicipio = (e) => {
    const idmunicipio = e.target.value;
    setZonaIdMunicipio(idmunicipio);
    setFiltroLocalidadZona("");

    if (!idmunicipio) {
      setLocalidadesZona([]);
      return;
    }

    setBuscandoZona(true);
    request
      .get(`Clientes/GetLocalidadesCRM?idmunicipio=${idmunicipio}`)
      .then((result) => setLocalidadesZona(result || []))
      .catch((error) => Swal.fire("CLIENTES", JSON.stringify(error), "error"))
      .finally(() => setBuscandoZona(false));
  };

  const handleSeleccionarZona = (l) => {
    setForm((prev) => ({ ...prev, idzona: l.idlocalidad, zona: l.localidad }));
    setMostrarBuscadorZona(false);
    setFiltroLocalidadZona("");
  };

  const handleQuitarZona = () => setForm((prev) => ({ ...prev, idzona: "", zona: "" }));

  // Coincidencias de localidades ya cargadas (por CP o municipio) que hacen match con el texto tecleado
  const localidadesZonaFiltradas = localidadesZona.filter((l) =>
    (l.localidad || "").toLowerCase().includes(filtroLocalidadZona.toLowerCase())
  );

  return (
    <div
      id="sec-generales"
      className="crm-detalle-card"
      style={{ scrollMarginTop: 170 }}
    >
      <div className="crm-detalle-card-header crm-detalle-card-header-actions">
        <div>
          <h3>Datos generales</h3>
          <p>
            {esNuevo
              ? "Captura la información básica del nuevo cliente"
              : `Información básica de identificación del cliente · ID ${idcliente}`}
          </p>
        </div>
        <div className="crm-detalle-card-header-buttons">
          {editing ? (
            <>
              {!esNuevo && (
                <button
                  type="button"
                  className="btn-icono-ghost"
                  title="Cancelar"
                  onClick={handleCancelar}
                >
                  <CloseIcon />
                </button>
              )}
              <button
                type="button"
                className="btn-icono-solido"
                title="Guardar cambios"
                onClick={handleGuardar}
              >
                <CheckIcon />
                <span>Guardar</span>
              </button>
            </>
          ) : (
            !soloLectura && (
              <button
                type="button"
                className="btn-icono-ghost btn-editar"
                title="Editar"
                onClick={handleEditar}
              >
                <EditIcon />
                <span>Editar</span>
              </button>
            )
          )}
        </div>
      </div>

      <div className="crm-detalle-card-body">
        <div className="crm-detalle-grid crm-detalle-grid-3">
          <div className="crm-field">
            <label>Razón social</label>
            <input
              type="text"
              className={fieldClass()}
              disabled={!editing}
              value={form.razonSocial}
              onChange={handleChange("razonSocial")}
            />
          </div>
          <div className="crm-field">
            <label>RFC</label>
            <input
              type="text"
              className={`mono ${fieldClass()}`}
              disabled={!editing}
              value={form.rfc}
              onChange={handleChange("rfc")}
            />
          </div>
          <div className="crm-field">
            <label>Tipo de régimen</label>
            <select
              className={fieldClass()}
              disabled={!editing}
              value={form.tipoRegimen}
              onChange={handleChange("tipoRegimen")}
            >
              <option value="Física">Física</option>
              <option value="Moral">Moral</option>
            </select>
          </div>
        </div>

        <div className="crm-detalle-grid crm-detalle-grid-3">
          <div className="crm-field">
            <label>Nombre completo</label>
            <input type="text" className={fieldClass()} disabled={!editing} value={form.nombreCompleto} onChange={handleChangeNombreCompleto} />
          </div>
          <div className="crm-field">
            <label>Teléfono</label>
            <input type="text" className={`mono ${fieldClass()}`} disabled={!editing} value={form.telefono} onChange={handleChangeTelefono} maxLength={10} />
          </div>
          <div className="crm-field">
            <label>Correo</label>
            <input type="text" className={fieldClass()} disabled={!editing} value={form.correo} onChange={handleChangeCorreo} maxLength={100} />
          </div>
        </div>

        {/* Estatus/Origen/Tipo de cliente — catálogos reales de Clientes/GetInfoClienteID */}
        {!esNuevo && (
          <div className="crm-detalle-grid crm-detalle-grid-3">
            <div className="crm-field">
              <label>Estatus</label>
              <select
                className={fieldClass()}
                disabled={!editing}
                value={form.estatus}
                onChange={handleChange("estatus")}
              >
                <option value="">Seleccionar</option>
                {opcionesGenerales.estatus.map((o) => (
                  <option key={o.id} value={o.id}>
                    {o.valor}
                  </option>
                ))}
              </select>
            </div>
            <div className="crm-field">
              <label>Origen</label>
              <select
                className={fieldClass()}
                disabled={!editing}
                value={form.origen}
                onChange={handleChange("origen")}
              >
                <option value="">Seleccionar</option>
                {opcionesGenerales.origen.map((o) => (
                  <option key={o.id} value={o.id}>
                    {o.valor}
                  </option>
                ))}
              </select>
            </div>
            <div className="crm-field">
              <label>Tipo de cliente</label>
              <select
                className={fieldClass()}
                disabled={!editing}
                value={form.tipoCliente}
                onChange={handleChange("tipoCliente")}
              >
                <option value="">Seleccionar</option>
                {opcionesGenerales.tipo.map((o) => (
                  <option key={o.id} value={o.id}>
                    {o.valor}
                  </option>
                ))}
              </select>
            </div>
            <div className="crm-field">
              <label>Etiqueta</label>
              <select className={fieldClass()} disabled={!editing} value={form.etiqueta} onChange={handleChange("etiqueta")}>
                <option value="">Seleccionar</option>
                {opcionesGenerales.etiqueta.map((o) => (
                  <option key={o.id} value={o.id}>{o.valor}</option>
                ))}
              </select>
            </div>
            <div className="crm-field crm-field-span-2">
              <label>Zona</label>
              {editing ? (
                <div className="crm-field-inline-btn-izq" ref={zonaPanelRef}>
                  <button type="button" className="btn-zona-buscar" title="Buscar zona" onClick={handleAbrirBuscadorZona}>
                    <SearchIcon fontSize="small" />
                  </button>
                  <div className="crm-field-cp-wrap">
                    <input type="text" className="crm-field-editable" readOnly value={form.zona} placeholder="Buscar zona..." onClick={handleAbrirBuscadorZona} />
                    {form.zona && (
                      <button type="button" className="btn-cp-limpiar" title="Quitar zona" onClick={handleQuitarZona}>×</button>
                    )}
                  </div>

                  {mostrarBuscadorZona && (
                    <div className="crm-field-zona-panel">
                      <div className="crm-field-zona-panel-grid">
                        <div className="crm-field">
                          <label>Código postal</label>
                          <div className="crm-field-inline-btn">
                            <div className="crm-field-cp-wrap">
                              <input
                                type="text"
                                className="mono crm-field-editable"
                                value={zonaCP}
                                onChange={(e) => setZonaCP(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && buscarZonaPorCP()}
                              />
                            </div>
                            <button type="button" className="btn-cp-buscar" title="Buscar por CP" disabled={!zonaCP || buscandoZona} onClick={buscarZonaPorCP}>
                              <SearchIcon fontSize="small" />
                            </button>
                          </div>
                        </div>
                        <div className="crm-field">
                          <label>Estado</label>
                          <select className="crm-field-editable" disabled={!!zonaCP} value={zonaIdEstado} onChange={handleChangeZonaEstado}>
                            <option value="">Seleccionar</option>
                            {opcionesUbicacion.estado
                              .filter((es) => esEstadoZonaPermitido(es.idestado))
                              .map((es) => (
                                <option key={es.idestado} value={es.idestado}>{es.estado}</option>
                              ))}
                          </select>
                        </div>
                        <div className="crm-field">
                          <label>Municipio</label>
                          <select className="crm-field-editable" disabled={!!zonaCP || !zonaIdEstado} value={zonaIdMunicipio} onChange={handleChangeZonaMunicipio}>
                            <option value="">Seleccionar</option>
                            {opcionesUbicacion.municipio
                              .filter((m) => String(m.idestado) === String(zonaIdEstado))
                              .map((m) => (
                                <option key={m.idmunicipio} value={m.idmunicipio}>{m.municipio}</option>
                              ))}
                          </select>
                        </div>
                      </div>

                      {localidadesZona.length > 0 && (
                        <>
                          <div className="crm-field">
                            <label>Buscar localidad</label>
                            <input
                              type="text"
                              className="crm-field-editable"
                              placeholder="Filtrar localidades..."
                              value={filtroLocalidadZona}
                              onChange={(e) => setFiltroLocalidadZona(e.target.value)}
                              autoFocus
                            />
                          </div>

                          <div className="crm-search-dropdown">
                            {localidadesZonaFiltradas.length === 0 ? (
                              <div className="crm-search-result crm-search-result-vacio">Sin resultados</div>
                            ) : (
                              localidadesZonaFiltradas.map((l) => (
                                <div key={l.idlocalidad} className="crm-search-result" onClick={() => handleSeleccionarZona(l)}>
                                  <div className="crm-res-info">
                                    <span className="crm-res-nombre">{l.localidad}</span>
                                  </div>
                                </div>
                              ))
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <input type="text" className="crm-field-readonly" disabled value={form.zona} placeholder="-" />
              )}
            </div>
          </div>
        )}

        <div className="crm-detalle-grid crm-detalle-grid-3">
          <div className="crm-field crm-field-span-3">
            <label>Propietario del cliente</label>
            {propietarioSeleccionado ? (
              <div className="crm-detalle-cliente-asociado">
                <div>
                  <span className="asociado-nombre">
                    {propietarioSeleccionado.vendedor}
                  </span>
                  <span className="asociado-id mono">
                    {propietarioSeleccionado.idvendedor}
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-quitar-asociado"
                  disabled={!editing}
                  onClick={handleQuitarPropietario}
                >
                  ×
                </button>
              </div>
            ) : (
              <div className="crm-home-search-section">
                <div
                  className={`crm-home-search-bar${resultadosPropietario.length > 0 ? " search-open" : ""}`}
                >
                  <SearchIcon className="crm-search-icon" />
                  <input
                    type="text"
                    className="crm-search-input"
                    placeholder="Buscar propietario por nombre..."
                    disabled={!editing}
                    value={busquedaPropietario}
                    onChange={(e) => setBusquedaPropietario(e.target.value)}
                    onFocus={() => setMostrarPropietarios(true)}
                    onBlur={() =>
                      setTimeout(() => setMostrarPropietarios(false), 150)
                    }
                    autoComplete="off"
                  />
                </div>

                {resultadosPropietario.length > 0 && (
                  <div className="crm-search-dropdown">
                    {resultadosPropietario.map((v) => (
                      <div
                        key={v.idvendedor}
                        className="crm-search-result"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => handleSeleccionarPropietario(v)}
                      >
                        <div className="crm-res-avatar">
                          <AccountCircleOutlinedIcon />
                        </div>
                        <div className="crm-res-info">
                          <span className="crm-res-nombre">{v.vendedor}</span>
                          <span className="crm-res-meta">
                            <BadgeIcon /> {v.idvendedor}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="crm-detalle-toggle-fila">
          <div className="crm-detalle-toggle-row">
            <span className="toggle-label">Cliente principal</span>
            <button
              type="button"
              className={`crm-toggle-switch${clientePrincipal ? " toggle-on" : ""}`}
              disabled={!editing}
              onClick={() => editing && setClientePrincipal((v) => !v)}
            >
              <span className="crm-toggle-knob" />
            </button>
          </div>

          {!esNuevo && (
            <div className="crm-detalle-toggle-row crm-detalle-toggle-validacion">
              <span className="toggle-label">Cliente validado</span>
              <button
                type="button"
                className={`crm-toggle-switch${validacion ? " toggle-on" : ""}`}
                disabled={!editing}
                onClick={() => editing && setValidacion((v) => !v)}
              >
                <span className="crm-toggle-knob" />
              </button>
            </div>
          )}
        </div>

        {!clientePrincipal && (
          <div className="crm-detalle-relacionado">
            {clienteAsociado ? (
              <div className="crm-detalle-cliente-asociado">
                <div>
                  <span className="asociado-nombre">
                    {clienteAsociado.razon_social}
                  </span>
                  <span className="asociado-id mono">
                    {clienteAsociado.rfc}
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-quitar-asociado"
                  disabled={!editing}
                  onClick={handleQuitarAsociado}
                >
                  ×
                </button>
              </div>
            ) : (
              <div className="crm-home-search-section crm-detalle-buscador-principal">
                <div
                  className={`crm-home-search-bar${resultadosClientePrincipal.length > 0 ? " search-open" : ""}`}
                >
                  <SearchIcon className="crm-search-icon" />
                  <input
                    type="text"
                    className="crm-search-input"
                    placeholder="Buscar cliente principal por razón social o RFC..."
                    disabled={!editing}
                    value={busquedaCliente}
                    onChange={(e) => setBusquedaCliente(e.target.value)}
                    autoComplete="off"
                  />
                </div>

                {resultadosClientePrincipal.length > 0 && (
                  <div className="crm-search-dropdown">
                    {resultadosClientePrincipal.map((c) => (
                      <div
                        key={c.idcliente}
                        className="crm-search-result"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => handleSeleccionarClientePrincipal(c)}
                      >
                        <div className="crm-res-avatar">
                          <AccountCircleOutlinedIcon />
                        </div>
                        <div className="crm-res-info">
                          <span className="crm-res-nombre">
                            {c.razon_social}
                          </span>
                          <span className="crm-res-meta">
                            <BadgeIcon /> {c.rfc}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      <div className="crm-detalle-card-footer">
        <CRM_LeyendaDepartamento responsables={responsableDepartamento} idrel={1} />
        <CRM_LeyendaAuditoria auditoria={auditoria} />
      </div>
    </div>
  );
};
